"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadingDefaultPlaceholder = exports.loadingOptionsPlaceholder = exports.convertToAlphanumericOnly = void 0;
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
const localizeUtils_1 = require("./localizeUtils");
function convertToAlphanumericOnly(appName) {
    return appName.replace(/[^\da-zA-Z]/g, "");
}
exports.convertToAlphanumericOnly = convertToAlphanumericOnly;
function loadingOptionsPlaceholder() {
    return localizeUtils_1.getLocalizedString("ui.select.LoadingOptionsPlaceholder");
}
exports.loadingOptionsPlaceholder = loadingOptionsPlaceholder;
function loadingDefaultPlaceholder() {
    return localizeUtils_1.getLocalizedString("ui.select.LoadingDefaultPlaceholder");
}
exports.loadingDefaultPlaceholder = loadingDefaultPlaceholder;
//# sourceMappingURL=utils.js.map